import React, { useCallback, useEffect, useState } from "react";
import { ModalHours } from "./ModalHours";
import { ModalLabel } from "./ModalLabel";
import { ModalColor } from "./ModalColor";
import { ModalSound } from "./ModalSound";
import "../assets/styles/modal.css";

export const Modal = ({
  visible,
  onClose,
  onSubmit,
  editItem,
  setSoundToPlay,
  setSoundPlaying,
  soundPlaying,
  soundToPlay,
}) => {
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [label, setLabel] = useState("");
  const [color, setColor] = useState("redish");
  const [sound, setSound] = useState("");
  const [show, setShow] = useState(visible);
  const [clicked, setClicked] = useState(false);
  const [, setTimere] = useState(null);
  const addHours = (stop) => {
    if (stop) {
      setTimere((p) => clearInterval(p));
    } else {
      setHours((p) => (p + 1 > 23 ? 0 : p + 1));
      setTimere(
        setInterval(() => {
          setHours((p) => (p + 1 > 23 ? 0 : p + 1));
        }, 200)
      );
    }
  };
  const subHours = (stop) => {
    if (stop) {
      setTimere((p) => clearInterval(p));
    } else {
      setHours((p) => (p - 1 < 0 ? 23 : p - 1));
      setTimere(
        setInterval(() => {
          setHours((p) => (p - 1 < 0 ? 23 : p - 1));
        }, 200)
      );
    }
  };

  const addMinutes = (stop) => {
    if (stop) {
      setTimere((p) => clearInterval(p));
    } else {
      setMinutes((p) => (p + 1 > 59 ? 0 : p + 1));
      setTimere(
        setInterval(() => {
          setMinutes((p) => (p + 1 > 59 ? 0 : p + 1));
        }, 200)
      );
    }
  };
  const subMinutes = (stop) => {
    if (stop) {
      setTimere((p) => clearInterval(p));
    } else {
      setMinutes((p) => (p - 1 < 0 ? 59 : p - 1));
      setTimere(
        setInterval(() => {
          setMinutes((p) => (p - 1 < 0 ? 59 : p - 1));
        }, 200)
      );
    }
  };

  const reset = useCallback(() => {
    setHours(() => 0);
    setMinutes(() => 0);
    setLabel(() => "");
    setColor(() => "redish");
    setSound(() => "");
    setSoundToPlay(() => "");
    setSoundPlaying(() => false);
    setClicked(() => false);
  }, [setSoundToPlay, setSoundPlaying]);

  const submit = () => {
    onSubmit({ hours, minutes, seconds: 0, label, color, sound });
    reset();
    onClose();
  };

  const close = () => {
    reset();
    onClose();
  };

  const onSetSound = (s) => {
    if (s === "doPause") {
      setSoundPlaying(false);
    } else if (s === "doPlay") {
      setSoundPlaying(true);
    } else if (s.length) {
      setSound(s);
    }
  };

  useEffect(() => {
    if (editItem) {
      setHours(editItem.hours);
      setMinutes(editItem.minutes);
      setLabel(editItem.label);
      setColor(editItem.color);
      setSound(editItem.sound);
    }
  }, [editItem]);

  useEffect(() => {
    if (!visible) {
      reset();
    }
    setShow(visible);
  }, [visible, reset]);

  useEffect(() => {
    if (sound.length) {
      setSoundToPlay(sound);
    } else setSoundToPlay("");
  }, [sound, setSoundToPlay]);

  useEffect(() => {
    if (soundToPlay.length && clicked) setSoundPlaying(true);
  }, [soundToPlay, setSoundPlaying, clicked]);

  return show ? (
    <div className="modal-backdrop">
      <div className="modal visible">
        <div className="modal-header">
          <h2 className="">{editItem ? "Edit" : "Add"} alarm</h2>
        </div>

        <div className="modal-body">
          {window.orientation !== undefined && (
            <p
              style={{
                backgroundColor: "var(--orangish)",
                borderRadius: 8,
                padding: 5,
                color: "black",
                fontWeight: 900,
              }}
            >
              Note: It looks like you are on mobile, make sure your screen will
              stay awake otherwise the alarm may not ring.
            </p>
          )}
          <ModalHours
            hours={hours}
            minutes={minutes}
            addHours={addHours}
            addMinutes={addMinutes}
            subHours={subHours}
            subMinutes={subMinutes}
          />
          <ModalLabel label={label} setLabel={setLabel} />
          <ModalColor setColor={setColor} color={color} />
          <ModalSound
            sound={sound}
            setSound={onSetSound}
            soundPlaying={soundPlaying}
            setClicked={setClicked}
          />
        </div>
        <p>
          Strictly necessary cookies are used on this site. By continuing to use
          kikiriki you agree to this use. Read more about how cookies are used
          in the{" "}
          <a href="/privacy-policy.html" className="privacy" target="blank">
            privacy policy
          </a>
        </p>
        <div className="modal-footer">
          <button className="btn" onClick={close}>
            Cancel
          </button>
          <button className="btn" onClick={submit}>
            Save
          </button>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
